import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { list_type, bool_type, int32_type, record_type, option_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";

export class IdentifierTypeDTO extends Record {
    constructor(Id, Description) {
        super();
        this.Id = Id;
        this.Description = Description;
    }
}

export function IdentifierTypeDTO$reflection() {
    return record_type("Admin.TelenorErrorReport.Model.IdentifierTypeDTO", [], IdentifierTypeDTO, () => [["Id", string_type], ["Description", option_type(string_type)]]);
}

export class FaultyService extends Record {
    constructor(customerSegment, serviceAgreement, identifier, serviceType) {
        super();
        this.customerSegment = customerSegment;
        this.serviceAgreement = serviceAgreement;
        this.identifier = identifier;
        this.serviceType = serviceType;
    }
}

export function FaultyService$reflection() {
    return record_type("Admin.TelenorErrorReport.Model.FaultyService", [], FaultyService, () => [["customerSegment", option_type(string_type)], ["serviceAgreement", option_type(string_type)], ["identifier", string_type], ["serviceType", string_type]]);
}

export class CustomerDTO extends Record {
    constructor(kid, customerName, city, country, postCode, district, street, contactName, contactPhoneNumber, reportedByName, reportedByPhoneNumber, notificationOption, notificationPhoneNumber, notificationEmail) {
        super();
        this.kid = kid;
        this.customerName = customerName;
        this.city = city;
        this.country = country;
        this.postCode = postCode;
        this.district = district;
        this.street = street;
        this.contactName = contactName;
        this.contactPhoneNumber = contactPhoneNumber;
        this.reportedByName = reportedByName;
        this.reportedByPhoneNumber = reportedByPhoneNumber;
        this.notificationOption = notificationOption;
        this.notificationPhoneNumber = notificationPhoneNumber;
        this.notificationEmail = notificationEmail;
    }
}

export function CustomerDTO$reflection() {
    return record_type("Admin.TelenorErrorReport.Model.CustomerDTO", [], CustomerDTO, () => [["kid", option_type(int32_type)], ["customerName", option_type(string_type)], ["city", option_type(string_type)], ["country", option_type(string_type)], ["postCode", option_type(string_type)], ["district", option_type(string_type)], ["street", option_type(string_type)], ["contactName", option_type(string_type)], ["contactPhoneNumber", option_type(string_type)], ["reportedByName", string_type], ["reportedByPhoneNumber", string_type], ["notificationOption", option_type(string_type)], ["notificationPhoneNumber", option_type(string_type)], ["notificationEmail", option_type(string_type)]]);
}

export class GeographicAddress extends Record {
    constructor(streetNr, streetName, stateOrProvince, county, country) {
        super();
        this.streetNr = streetNr;
        this.streetName = streetName;
        this.stateOrProvince = stateOrProvince;
        this.county = county;
        this.country = country;
    }
}

export function GeographicAddress$reflection() {
    return record_type("Admin.TelenorErrorReport.Model.GeographicAddress", [], GeographicAddress, () => [["streetNr", option_type(string_type)], ["streetName", option_type(string_type)], ["stateOrProvince", option_type(string_type)], ["county", option_type(string_type)], ["country", option_type(string_type)]]);
}

export class Size extends Record {
    constructor(amount, units) {
        super();
        this.amount = amount;
        this.units = units;
    }
}

export function Size$reflection() {
    return record_type("Admin.TelenorErrorReport.Model.Size", [], Size, () => [["amount", option_type(int32_type)], ["units", option_type(string_type)]]);
}

export class ValidFor extends Record {
    constructor(endDateTime, startDateTime) {
        super();
        this.endDateTime = endDateTime;
        this.startDateTime = startDateTime;
    }
}

export function ValidFor$reflection() {
    return record_type("Admin.TelenorErrorReport.Model.ValidFor", [], ValidFor, () => [["endDateTime", option_type(string_type)], ["startDateTime", option_type(string_type)]]);
}

export class Attachment extends Record {
    constructor(id, href, attachmentType, content, description, mimeType, name, url, size, validFor) {
        super();
        this.id = id;
        this.href = href;
        this.attachmentType = attachmentType;
        this.content = content;
        this.description = description;
        this.mimeType = mimeType;
        this.name = name;
        this.url = url;
        this.size = size;
        this.validFor = validFor;
    }
}

export function Attachment$reflection() {
    return record_type("Admin.TelenorErrorReport.Model.Attachment", [], Attachment, () => [["id", option_type(string_type)], ["href", option_type(string_type)], ["attachmentType", option_type(string_type)], ["content", option_type(string_type)], ["description", option_type(string_type)], ["mimeType", option_type(string_type)], ["name", option_type(string_type)], ["url", option_type(string_type)], ["size", option_type(Size$reflection())], ["validFor", option_type(ValidFor$reflection())]]);
}

export class Customer extends Record {
    constructor(kid, customerName, city, country, postCode, district, street, contactName, contactPhoneNumber, reportedByName, reportedByPhoneNumber, notificationOption, notificationPhoneNumber, notificationEmail) {
        super();
        this.kid = kid;
        this.customerName = customerName;
        this.city = city;
        this.country = country;
        this.postCode = postCode;
        this.district = district;
        this.street = street;
        this.contactName = contactName;
        this.contactPhoneNumber = contactPhoneNumber;
        this.reportedByName = reportedByName;
        this.reportedByPhoneNumber = reportedByPhoneNumber;
        this.notificationOption = notificationOption;
        this.notificationPhoneNumber = notificationPhoneNumber;
        this.notificationEmail = notificationEmail;
    }
}

export function Customer$reflection() {
    return record_type("Admin.TelenorErrorReport.Model.Customer", [], Customer, () => [["kid", option_type(int32_type)], ["customerName", option_type(string_type)], ["city", option_type(string_type)], ["country", option_type(string_type)], ["postCode", option_type(string_type)], ["district", option_type(string_type)], ["street", option_type(string_type)], ["contactName", option_type(string_type)], ["contactPhoneNumber", option_type(string_type)], ["reportedByName", string_type], ["reportedByPhoneNumber", string_type], ["notificationOption", option_type(string_type)], ["notificationPhoneNumber", option_type(string_type)], ["notificationEmail", option_type(string_type)]]);
}

export function Customer_get_Default() {
    return new Customer(void 0, void 0, void 0, void 0, void 0, void 0, void 0, void 0, void 0, "", "", void 0, void 0, void 0);
}

export class IdentifierType extends Record {
    constructor(id, description) {
        super();
        this.id = id;
        this.description = description;
    }
}

export function IdentifierType$reflection() {
    return record_type("Admin.TelenorErrorReport.Model.IdentifierType", [], IdentifierType, () => [["id", string_type], ["description", option_type(string_type)]]);
}

export function IdentifierType_get_Default() {
    return new IdentifierType("", void 0);
}

export class ServiceProblem extends Record {
    constructor(externalId, systemName, category) {
        super();
        this.externalId = externalId;
        this.systemName = systemName;
        this.category = category;
    }
}

export function ServiceProblem$reflection() {
    return record_type("Admin.TelenorErrorReport.Model.ServiceProblem", [], ServiceProblem, () => [["externalId", option_type(string_type)], ["systemName", option_type(string_type)], ["category", option_type(string_type)]]);
}

export class RelatedLocation extends Record {
    constructor(name, description, geographicAddress) {
        super();
        this.name = name;
        this.description = description;
        this.geographicAddress = geographicAddress;
    }
}

export function RelatedLocation$reflection() {
    return record_type("Admin.TelenorErrorReport.Model.RelatedLocation", [], RelatedLocation, () => [["name", option_type(string_type)], ["description", option_type(string_type)], ["geographicAddress", option_type(GeographicAddress$reflection())]]);
}

export class Note extends Record {
    constructor(id, externalId, author, authorFirstName, authorLastName, authorGroupName, date, internal, text) {
        super();
        this.id = id;
        this.externalId = externalId;
        this.author = author;
        this.authorFirstName = authorFirstName;
        this.authorLastName = authorLastName;
        this.authorGroupName = authorGroupName;
        this.date = date;
        this.internal = internal;
        this.text = text;
    }
}

export function Note$reflection() {
    return record_type("Admin.TelenorErrorReport.Model.Note", [], Note, () => [["id", option_type(string_type)], ["externalId", option_type(string_type)], ["author", option_type(string_type)], ["authorFirstName", option_type(string_type)], ["authorLastName", option_type(string_type)], ["authorGroupName", option_type(string_type)], ["date", option_type(string_type)], ["internal", option_type(bool_type)], ["text", option_type(string_type)]]);
}

export class RelatedEntity extends Record {
    constructor(id, href, name, role) {
        super();
        this.id = id;
        this.href = href;
        this.name = name;
        this.role = role;
    }
}

export function RelatedEntity$reflection() {
    return record_type("Admin.TelenorErrorReport.Model.RelatedEntity", [], RelatedEntity, () => [["id", string_type], ["href", option_type(string_type)], ["name", option_type(string_type)], ["role", string_type]]);
}

export class RelatedParty extends Record {
    constructor(id, href, name, role) {
        super();
        this.id = id;
        this.href = href;
        this.name = name;
        this.role = role;
    }
}

export function RelatedParty$reflection() {
    return record_type("Admin.TelenorErrorReport.Model.RelatedParty", [], RelatedParty, () => [["id", string_type], ["href", option_type(string_type)], ["name", option_type(string_type)], ["role", option_type(string_type)]]);
}

export class StatusChange extends Record {
    constructor(changeDate, changeReason, status) {
        super();
        this.changeDate = changeDate;
        this.changeReason = changeReason;
        this.status = status;
    }
}

export function StatusChange$reflection() {
    return record_type("Admin.TelenorErrorReport.Model.StatusChange", [], StatusChange, () => [["changeDate", option_type(string_type)], ["changeReason", option_type(string_type)], ["status", option_type(string_type)]]);
}

export class TroubleTicketRelationship extends Record {
    constructor(id, href, name, relationshipType) {
        super();
        this.id = id;
        this.href = href;
        this.name = name;
        this.relationshipType = relationshipType;
    }
}

export function TroubleTicketRelationship$reflection() {
    return record_type("Admin.TelenorErrorReport.Model.TroubleTicketRelationship", [], TroubleTicketRelationship, () => [["id", option_type(string_type)], ["href", option_type(string_type)], ["name", option_type(string_type)], ["relationshipType", option_type(string_type)]]);
}

export class Channel extends Record {
    constructor(id, href, name) {
        super();
        this.id = id;
        this.href = href;
        this.name = name;
    }
}

export function Channel$reflection() {
    return record_type("Admin.TelenorErrorReport.Model.Channel", [], Channel, () => [["id", string_type], ["href", option_type(string_type)], ["name", option_type(string_type)]]);
}

export class TroubleTicketPOST extends Record {
    constructor(creationDate, description, name, severity, ticketType, customer, faultyService, identifierType, note, statusChange) {
        super();
        this.creationDate = creationDate;
        this.description = description;
        this.name = name;
        this.severity = severity;
        this.ticketType = ticketType;
        this.customer = customer;
        this.faultyService = faultyService;
        this.identifierType = identifierType;
        this.note = note;
        this.statusChange = statusChange;
    }
}

export function TroubleTicketPOST$reflection() {
    return record_type("Admin.TelenorErrorReport.Model.TroubleTicketPOST", [], TroubleTicketPOST, () => [["creationDate", string_type], ["description", string_type], ["name", option_type(string_type)], ["severity", string_type], ["ticketType", string_type], ["customer", Customer$reflection()], ["faultyService", FaultyService$reflection()], ["identifierType", IdentifierType$reflection()], ["note", list_type(Note$reflection())], ["statusChange", list_type(StatusChange$reflection())]]);
}

export class TroubleTicketGET extends Record {
    constructor(id, href, creationDate, description, expectedResolutionDate, externalId, lastUpdate, name, priority, requestedResolutionDate, resolutionDate, severity, statusChangeDate, statusChangeReason, ticketType, customer, responsibleOrganization, responsibleUser, faultyService, sourceSystem, county, district, identifierType, nodeId, serviceProblems, resolution, relatedLocation, attachment, channel, note, relatedEntity, relatedParty, status, statusChange, troubleTicketRelationship) {
        super();
        this.id = id;
        this.href = href;
        this.creationDate = creationDate;
        this.description = description;
        this.expectedResolutionDate = expectedResolutionDate;
        this.externalId = externalId;
        this.lastUpdate = lastUpdate;
        this.name = name;
        this.priority = priority;
        this.requestedResolutionDate = requestedResolutionDate;
        this.resolutionDate = resolutionDate;
        this.severity = severity;
        this.statusChangeDate = statusChangeDate;
        this.statusChangeReason = statusChangeReason;
        this.ticketType = ticketType;
        this.customer = customer;
        this.responsibleOrganization = responsibleOrganization;
        this.responsibleUser = responsibleUser;
        this.faultyService = faultyService;
        this.sourceSystem = sourceSystem;
        this.county = county;
        this.district = district;
        this.identifierType = identifierType;
        this.nodeId = nodeId;
        this.serviceProblems = serviceProblems;
        this.resolution = resolution;
        this.relatedLocation = relatedLocation;
        this.attachment = attachment;
        this.channel = channel;
        this.note = note;
        this.relatedEntity = relatedEntity;
        this.relatedParty = relatedParty;
        this.status = status;
        this.statusChange = statusChange;
        this.troubleTicketRelationship = troubleTicketRelationship;
    }
}

export function TroubleTicketGET$reflection() {
    return record_type("Admin.TelenorErrorReport.Model.TroubleTicketGET", [], TroubleTicketGET, () => [["id", string_type], ["href", option_type(string_type)], ["creationDate", option_type(string_type)], ["description", option_type(string_type)], ["expectedResolutionDate", option_type(string_type)], ["externalId", option_type(string_type)], ["lastUpdate", option_type(string_type)], ["name", option_type(string_type)], ["priority", option_type(string_type)], ["requestedResolutionDate", option_type(string_type)], ["resolutionDate", option_type(string_type)], ["severity", option_type(string_type)], ["statusChangeDate", option_type(string_type)], ["statusChangeReason", option_type(string_type)], ["ticketType", option_type(string_type)], ["customer", option_type(Customer$reflection())], ["responsibleOrganization", option_type(string_type)], ["responsibleUser", option_type(string_type)], ["faultyService", option_type(FaultyService$reflection())], ["sourceSystem", option_type(string_type)], ["county", option_type(string_type)], ["district", option_type(string_type)], ["identifierType", option_type(IdentifierType$reflection())], ["nodeId", option_type(string_type)], ["serviceProblems", option_type(list_type(ServiceProblem$reflection()))], ["resolution", option_type(string_type)], ["relatedLocation", option_type(RelatedLocation$reflection())], ["attachment", option_type(list_type(Attachment$reflection()))], ["channel", option_type(Channel$reflection())], ["note", option_type(list_type(Note$reflection()))], ["relatedEntity", option_type(list_type(RelatedEntity$reflection()))], ["relatedParty", option_type(list_type(RelatedParty$reflection()))], ["status", option_type(string_type)], ["statusChange", option_type(list_type(StatusChange$reflection()))], ["troubleTicketRelationship", option_type(list_type(TroubleTicketRelationship$reflection()))]]);
}

